module.exports = __webpack_public_path__ + "static/stephanie-hamon-chris-grant-3f83f656548c4c32020a9b9a0cd3c97c.png";